import { Tabs } from 'antd';
import { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import PPPageHeader from '../../components/pageHeader/PPPageHeader';
import ClientsActive from './ClientsActive';

const ALL_TABS = [{ key: 'active', label: 'Идэвхитэй' }];

const Clients = () => {
  const history = useHistory();
  const location = useLocation();

  const initialTab = new URLSearchParams(location.search).get('tab') || ALL_TABS[0].key;
  const getValidKey = (key) => (ALL_TABS.find((item) => item.key === key) ? key : ALL_TABS[0].key);

  const [currentKey, setCurrentKey] = useState(() => getValidKey(initialTab));

  const onChange = (key) => {
    setCurrentKey(key);
    history.replace({
      pathname: location.pathname,
      search: `?tab=${key}`,
      state: location.state,
    });
  };

  return (
    <div>
      <PPPageHeader title="Харилцагчид" />
      <Tabs
        activeKey={currentKey}
        onChange={onChange}
        items={ALL_TABS}
        tabBarStyle={{ marginBottom: 0, margin: '0', padding: '0 12px' }}
      />

      {/* Таб бүр эргэн тойрны зайгаа өөрөө агуулна тул wrapper-гүй */}
      {currentKey === 'active' && <ClientsActive />}
    </div>
  );
};

export default Clients;
